import React from 'react'
import Signup from '../Components/SignUp/Signup';
const SignUpPage = () => {
  return (
    <Signup />
  )
}

export default SignUpPage